import {
  HANDLE_API_ERROR,
  NETWORK_ERROR,
  AUTH_ERROR,
  CLEAR_ERROR,
  SHOW_ERROR_MESSAGE,
  HIDE_ERROR_MESSAGE,
  SET_ERROR_CONTEXT
} from './actions';

const initialState = {
  hasError: false,
  errorType: null, // 'network', 'auth', 'unknown'
  errorMessage: null,
  errorContext: null,
  originalError: null,
  showMessage: false,
  timestamp: null
};

const networkErrorHandlingReducer = (state = initialState, action) => {
  switch (action.type) {
    case HANDLE_API_ERROR:
      return {
        ...state,
        hasError: true,
        originalError: action.payload.error,
        errorContext: action.payload.context,
        timestamp: new Date().toISOString()
      };

    case NETWORK_ERROR:
      return {
        ...state,
        hasError: true,
        errorType: 'network',
        errorMessage: action.payload.message,
        errorContext: action.payload.context,
        originalError: action.payload.error,
        showMessage: true,
        timestamp: new Date().toISOString()
      };

    case AUTH_ERROR:
      return {
        ...state,
        hasError: true,
        errorType: 'auth',
        errorMessage: action.payload.message,
        errorContext: action.payload.context,
        originalError: action.payload.error,
        showMessage: true,
        timestamp: new Date().toISOString()
      };

    case SHOW_ERROR_MESSAGE:
      return {
        ...state,
        showMessage: true,
        errorMessage: action.payload.message,
        errorType: action.payload.type,
        errorContext: action.payload.context,
        timestamp: new Date().toISOString()
      };

    case HIDE_ERROR_MESSAGE:
      return {
        ...state,
        showMessage: false,
        errorMessage: null
      };

    case CLEAR_ERROR:
      return {
        ...initialState
      };

    case SET_ERROR_CONTEXT:
      return {
        ...state,
        errorContext: action.payload.context
      };

    default:
      return state;
  }
};

export default networkErrorHandlingReducer;
